import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const getUserType = async (accessToken) => {

    try {
        const response = await axiosInstance.get("/user/@me", {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
          const status = error.response.status;
          const errorMessage = error.response.data?.error || error?.message;
          if (errorMessage) {
            toast.error(errorMessage);
            window.location.href = "/login";

          }

          else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
          
        } else {
          // خطاهای مربوط به شبکه یا سرور
          toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
        }
      }
};
